import Home from './home';
import Categories from './categories';
import Store from './store';
import BestSeller from './bestSeller';
import About from './about';
import Contact from './comtact';
import WhatsAppButton from '../../common/whatsapp';
export default function HomePage() {
    return (
        <>
            <WhatsAppButton />
            <Home />
            <Categories />
            <Store />
            <BestSeller />
            <About />
            <Contact />
        </>
    )
}
